import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { InputAdornment, Slider } from '@material-ui/core';
import { Inputs } from '../../../../Components';
import './PriceFilter.scss';

export const PriceFilter = ({
  parentTranslationPath,
  translationPath,
  selected,
  setSelected,
  PriceAndSizeChangeFilters,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const searchTimer = useRef(null);

  const handleSliderChange = (event, newValue) => {
    const [minValue, maxValue] = newValue;
    setSelected({ id: 'price', value: { from: minValue, to: maxValue } });
    if (searchTimer.current) {
      clearTimeout(searchTimer.current);
    }
    searchTimer.current = setTimeout(() => {
      PriceAndSizeChangeFilters('Selling_price', {
        from: minValue,
        to: maxValue,
      });
    }, 1000);
  };

  const handleInputChange = (value, type) => {
    if (type === 'from') {
      setSelected({
        id: 'price',
        value: { from: value },
      });
      if (searchTimer.current) {
        clearTimeout(searchTimer.current);
      }
      searchTimer.current = setTimeout(() => {
        PriceAndSizeChangeFilters('Selling_price', {
          from: value,
          to: selected?.price?.to,
        });
      }, 1000);
    } else {
      setSelected({
        id: 'price',
        value: { from: selected?.price?.from, to: value },
      });
      if (searchTimer.current) {
        clearTimeout(searchTimer.current);
      }
      searchTimer.current = setTimeout(() => {
        PriceAndSizeChangeFilters('Selling_price', {
          from: selected?.price?.from,
          to: value,
        });
      }, 1000);
    }
  };

  return (
    <div className='price-filter-container'>
      <fieldset className='styled-fieldset'>
        <legend className='styled-legend'>
          {t(`${translationPath}price`)}
        </legend>
        <div className='slider-container'>
          <Slider
            value={[Number(selected?.price?.from), Number(selected?.price?.to)]}
            onChange={handleSliderChange}
            min={10000}
            max={60000000}
            valueLabelDisplay='auto'
          />
        </div>
        <div className='inputs-container'>
          <Inputs
            idRef='priceFromRef'
            type='number'
            labelValue={t(`${translationPath}Min`)}
            value={selected?.price?.from || 10000}
            onInputChanged={(event) => {
              const { value } = event.target;
              handleInputChange(value, 'from');
            }}
            endAdornment={<InputAdornment position='start'>AED</InputAdornment>}
            min={0}
            className='price-input'
          />
          <span className='range-separator'>-</span>
          <Inputs
            idRef='priceToRef'
            type='number'
            labelValue={t(`${translationPath}Max`)}
            value={selected?.price?.to || 60000000}
            onInputChanged={(event) => {
              const { value } = event.target;
              handleInputChange(value, 'to');
            }}
            endAdornment={<InputAdornment position='start'>AED</InputAdornment>}
            min={0}
          />
        </div>
      </fieldset>
    </div>
  );
};
